import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = {
        rentalPeriodFieldId: Number,
        arrivalTimeFieldId: Number,
        arrivalTimeErrorMessage: String
    }

    validateArrivalTime() {
        const arrivalInput = this.element.querySelector(
            `input[name="response[${this.arrivalTimeFieldIdValue}]"]`
        )
        const errorElement = this.element.querySelector(
            `#blueprint-field-error-${this.arrivalTimeFieldIdValue}`
        )

        if (!arrivalInput || !errorElement) return

        const rentalPeriodInput = this.element.querySelector(
            `input[name="response[${this.rentalPeriodFieldIdValue}]"]:checked`
        )
        const invalid = arrivalInput.value !== '' && !this.withinRentalPeriod(
            arrivalInput.value,
            rentalPeriodInput?.value
        )

        errorElement.textContent = invalid ? this.arrivalTimeErrorMessageValue : ''
        arrivalInput.setAttribute('aria-invalid', invalid.toString())
        this.updateInputClasses(arrivalInput, invalid)
    }

    withinRentalPeriod(arrivalTime, rentalPeriod) {
        const arrivalMatch = arrivalTime?.match(/^(\d{2}):(\d{2})$/)
        const periodMatch = rentalPeriod?.match(/(\d{2}):(\d{2})\s*-\s*(\d{2}):(\d{2})/)
        if (!arrivalMatch || !periodMatch) return false

        const arrivalMinutes = this.minutes(arrivalMatch[1], arrivalMatch[2])
        const startMinutes = this.minutes(periodMatch[1], periodMatch[2])
        const endMinutes = this.minutes(periodMatch[3], periodMatch[4])

        return arrivalMinutes >= startMinutes && arrivalMinutes <= endMinutes
    }

    minutes(hours, minutes) {
        return (Number(hours) * 60) + Number(minutes)
    }

    updateInputClasses(input, invalid) {
        input.classList.toggle('border-red', invalid)
        input.classList.toggle('focus:border-red', invalid)
        input.classList.toggle('border-gray-800', !invalid)
        input.classList.toggle('focus:border-primary', !invalid)
    }
}
